/* Keep Mailchimp's forms while exposing their existing shared div as a dialog. */
(() => {
  const hostId = 'mcforms-156609-187789';
  const observedRoots = new WeakSet();
  const modalStates = new WeakMap();

  function repair(root) {
    root.querySelectorAll('div[data-test-class="variation-wrapper"]').forEach((wrapper) => {
      const forms = Array.from(wrapper.querySelectorAll(':scope > form.step[data-amped-type="step"]'));
      if (!forms.length) return;
      const label = forms.find((form) => form.hasAttribute('aria-labelledby'))?.getAttribute('aria-labelledby');
      // Fail safely if the app changes its known, labelled structure.
      if (!label || !label.split(/\s+/).every((id) => root.getElementById(id))) return;
      // This first-step red surface sits behind normal-size white subtitle text.
      // Retain the vendor's translucency while providing 4.5:1 text contrast.
      if (wrapper.querySelector('#el_WjQfgwkOZh') && !root.getElementById('zion-popup-contrast')) {
        const style = document.createElement('style');
        style.id = 'zion-popup-contrast';
        style.textContent = '#el_WjQfgwkOZh { background-color: rgba(215, 46, 36, 0.97) !important; }';
        root.appendChild(style);
      }
      forms.forEach((form) => {
        if (form.hasAttribute('aria-modal')) modalStates.set(form, form.getAttribute('aria-modal'));
      });
      const set = (element, name, value) => {
        if (element.getAttribute(name) !== value) element.setAttribute(name, value);
      };
      set(wrapper, 'role', 'dialog');
      set(wrapper, 'aria-labelledby', label);
      set(wrapper, 'aria-modal', String(forms.some((form) => form.classList.contains('visible') && form.style.display !== 'none' && modalStates.get(form) === 'true')));
      forms.forEach((form) => {
        // Preserve nodes, focus targets, native submission, and vendor listeners.
        if (form.getAttribute('role') === 'dialog') form.removeAttribute('role');
        if (form.hasAttribute('aria-modal')) form.removeAttribute('aria-modal');
      });
    });
  }

  function connect() {
    const root = document.getElementById(hostId)?.shadowRoot;
    if (!root || observedRoots.has(root)) return;
    observedRoots.add(root);
    repair(root);
    new MutationObserver(() => repair(root)).observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['role', 'aria-modal', 'aria-labelledby', 'class', 'style'],
    });
  }

  // Shadow-root attachment does not emit a document mutation. Retry at startup,
  // and discover replacement hosts after app or theme-editor DOM updates.
  new MutationObserver(connect).observe(document, { childList: true, subtree: true });
  connect();
  let attempts = 0;
  const startup = setInterval(() => {
    connect();
    if (document.getElementById(hostId)?.shadowRoot || ++attempts === 120) clearInterval(startup);
  }, 500);
})();
